import React, {
  useEffect,
  useState,
  useContext,
  lazy,
  useCallback,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import MarkChatUnreadIcon from "@mui/icons-material/MarkChatUnread";
// import NotificationsIcon from "@mui/icons-material/Notifications";

import { Avatar } from "@mui/material";
// import plusLogo from "./img/logo.png";
// import UploadBlog from "../uploads/UploadBlog";
// import UploadImage from "../uploads/UploadImage";
// import UploadVideos from "../uploads/UploadVideos";
import VideocamIcon from "@mui/icons-material/Videocam";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import axios from "axios";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
// import { FaRegCompass } from "react-icons/fa";
// import HomeIcon from "@mui/icons-material/Home";
import { ReactComponent as HomeIcon } from "../../img/footer/home.svg";
import { ReactComponent as TimelineIcon } from "../../img/footer/world.svg";
// import { ReactComponent as postBtn } from "../../img/footer/post.svg";
// import { ReactComponent as chatsIcon } from "../../img/footer/message.svg";
import Man from "../Header/img/Man.svg";
import Female from "../Header/img/Female.svg";
import Others from "../Header/img/Others.svg";
import logoAnt from "../Header/img/Ant.png";
import logoAntDark from "../Header/img/Ant_Dark.png";
import { toast } from "react-toastify";

import { path } from "../../path";
// import MessageNoti from "./img/messagenoti.svg";
// import Noti from "./img/noti.svg";
// import Add from "./img/add.svg";
import { WebSocketContext } from "../../WebSocket";
import Skillmodel from "../SelectSkills/Skillmodel";
const UploadBlog = lazy(() => import("../uploads/UploadBlog"));
const UploadImage = lazy(() => import("../uploads/UploadImage"));
const UploadVideos = lazy(() => import("../uploads/UploadVideos"));

// const styles = {
//   largeIcon: {
//     width: 80,
//     height: 60,
//   },
// };

// let color = ["Orange", "Red", "Yellow", "Blue", "Green"];
// let i = Math.floor(Math.random() * 5);

const MobileFooter = () => {
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.AuthReducer);
  // const { notification: noti } = useSelector(
  //   (state) => state.NotificationReducer
  // );
  const [redirectModal, setRedirectModal] = useState(false);
  // const [friendRequestsCnt, setFriendRequestsCnt] = useState(0);
  // const [profilePictureColor, setProfilePictureColor] = useState(color[i]);
  const [togglePostDropdown, settogglePostDropdown] = useState(false);
  const [togglePostContent, settogglePostContent] = useState(false);
  const [togglePostImageContent, settogglePostImageContent] = useState(false);
  const [togglePostVideoContent, settogglePostVideoContent] = useState(false);
  // const [unseenNotification, setunseenNotification] = useState(false);
  // const [messageUnseen, setMessageUnseen] = useState(false);
  // const [clicked, setclicked] = useState(false);
  const getAllFriendRequests = async () => {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": `${path}`,
        Authorization: `Bearer ${token}`,
      },
    };
    await axios.get(`${path}/friendRequests/${user._id}`, config);
    // setFriendRequestsCnt(res.data.friendrequests.length);
  };
  //changing colors randomly for name image
  // useEffect(() => {

  //   setProfilePictureColor(color[i]);
  // }, [profilePictureColor]);

  useEffect(() => {
    getAllFriendRequests();
  }, []);
  const toastOption = {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 3000,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
  };
  // Handle Post Dropdown
  const handlePostDropdown = (e) => {
    // console.log("button is clicked");
    if (user.skills.length === 0) {
      setRedirectModal(true);
      toast.error("Select skills to post any content!", toastOption);
    } else {
      e.preventDefault();
      settogglePostDropdown((prev) => !prev);
      settogglePostContent(false);
      settogglePostImageContent(false);
      settogglePostVideoContent(false);
    }
  };

  const handletogglePostContent = useCallback(() => {
    settogglePostContent(!togglePostContent);
    settogglePostVideoContent(false);
    settogglePostDropdown(false);
    settogglePostImageContent(false);
  }, [togglePostContent]);

  const handletogglePosImagetContent = useCallback(() => {
    settogglePostImageContent((tgl) => !tgl);

    settogglePostContent(false);
    settogglePostVideoContent(false);
    settogglePostDropdown(false);
  }, [togglePostImageContent]);

  const handletogglePostVideoContent = useCallback(() => {
    settogglePostContent(false);
    settogglePostVideoContent(!togglePostVideoContent);
    settogglePostImageContent(false);
    settogglePostDropdown(false);
  }, [togglePostVideoContent]);

  const socket = useContext(WebSocketContext);
  // const config = {
  //   headers: {
  //     "Access-Control-Allow-Origin": `${path}`,
  //     Authorization: `Bearer ${token}`,
  //   },
  // };
  useEffect(() => {
    // const getNotification = async () => {
    //   try {
    //     const response = await axios.get(
    //       `${path}/getNotification/${user._id}`,
    //       config
    //     );
    //     const filteredNoti = response.data.data.filter(
    //       (noti) =>
    //         noti.fromUserId !== null &&
    //         noti.type !== "Not Improve" &&
    //         noti.type !== "Unappreciate" &&
    //         noti.postId !== null
    //     );
    //     dispatch({ type: "UPDATE_NOTIFICATION", payload: filteredNoti });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };

    // getNotification();
    socket.on("notification received", () => {
      dispatch({ type: "SET_NOTIFICATION" });
      // getNotification();
      // setunseenNotification(true);
    });
    socket.on("profile update", () => {
      dispatch({ type: "SET_NOTIFICATION" });
      // getNotification();
      // setunseenNotification(true);
    });

    socket.on("friend received", () => {
      dispatch({ type: "SET_NOTIFICATION" });
      // getNotification();
      // setunseenNotification(true);
    });

    socket.on("post notification recieved", () => {
      dispatch({ type: "SET_NOTIFICATION" });
      // getNotification();
      // setunseenNotification(true);
    });

    socket.on("pull cancel", () => {
      dispatch({ type: "UNSET_NOTIFICATION" });
      // getNotification();
      // setunseenNotification(false);
    });

    socket.on("uni-message-socket-recieved", () => {
      dispatch({ type: "SET_MSG_NOTIFICATION" });
      // getNotification();
      // setMessageUnseen(true);
    });
  }, []);

  return (
    <div>
      {redirectModal && (
        <div className="z-50 absolute flex flex-col justify-center  w-[100vw] h-[100vh] bg-transparent">
          <Skillmodel></Skillmodel>
        </div>
      )}
      <div
        className="fixed flex justify-between items-center bottom-0 right-0 left-0  p-3 sm:hidden md:hidden z-[5] bg-card text-primary rounded h-12"
        style={{ boxShadow: "2px 0px 4px 2px rgba(0, 0, 0, 0.25)" }}>
        <div>
          <Link to="/home">
            <HomeIcon
            // fontSize="large"
            // sx={{
            //   color:
            //     (window.location.hash === "#/home") === true
            //       ? "#008080"
            //       : "#ACACAC",
            //   height: 35,
            //   width: 35,
            // }}
            />
          </Link>
        </div>
        <div>
          <Link to="/timeline" onClick={() => {}}>
            {/* <FaRegCompass
              size={32}
              color={
                (window.location.hash === "#/timeline") === true
                  ? "#008080"
                  : "#ACACAC"
              }
            /> */}
            <TimelineIcon
              className={`text-[${
                (window.location.hash === "#/timeline") === true
                  ? "#008080"
                  : "#ACACAC"
              }]`}
            />
          </Link>
        </div>

        <div className="">
          <a onClick={handlePostDropdown} className="hover:cursor-pointer">
            {/* <img src={plusLogo} alt="" /> */}
            {/* <Avatar src={Add} sx={{ width: 60, height: 60 }} /> */}
            {/* <postBtn /> */}
            <svg
              width="40"
              height="39"
              viewBox="0 0 40 39"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <rect
                x="0.736816"
                width="39"
                height="39"
                rx="11"
                fill="#008080"
              />
              <g clipPath="url(#clip0_6_4239)">
                <path
                  d="M20.2368 12C18.7535 12 17.3034 12.4399 16.07 13.264C14.8367 14.0881 13.8754 15.2594 13.3077 16.6299C12.7401 18.0003 12.5915 19.5083 12.8809 20.9632C13.1703 22.418 13.8846 23.7544 14.9335 24.8033C15.9824 25.8522 17.3188 26.5665 18.7736 26.8559C20.2285 27.1453 21.7365 26.9968 23.1069 26.4291C24.4774 25.8614 25.6487 24.9001 26.4728 23.6668C27.297 22.4334 27.7368 20.9834 27.7368 19.5C27.7347 17.5115 26.9438 15.6051 25.5377 14.1991C24.1317 12.793 22.2253 12.0022 20.2368 12ZM23.3618 20.125H20.8618V22.625H19.6118V20.125H17.1118V18.875H19.6118V16.375H20.8618V18.875H23.3618V20.125Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_6_4239">
                  <rect
                    width="15"
                    height="15"
                    fill="white"
                    transform="translate(12.7368 12)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
        </div>
        <div>
          <Link to="/competition">
            <span className=" mt-[2%]">
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.73728 10H8.23699C11.8849 10 13.1792 7.81252 13.1792 5.93752C13.1787 5.42939 13.0227 4.93732 12.7381 4.5458C12.4536 4.15427 12.0581 3.88772 11.6197 3.7919C11.7075 3.58993 11.7826 3.38106 11.8442 3.1669C11.9401 2.80124 11.9589 2.41502 11.8992 2.03954C11.8395 1.66405 11.7029 1.30985 11.5005 1.00565C11.2963 0.692173 11.0301 0.4378 10.7235 0.2631C10.4169 0.0884008 10.0785 -0.00172037 9.73558 2.48729e-05H3.44361C3.1006 -0.00150371 2.76208 0.0889061 2.45547 0.263937C2.14885 0.438968 1.88275 0.693703 1.6787 1.00752C1.47629 1.31173 1.3397 1.66592 1.27997 2.04141C1.22025 2.4169 1.23908 2.80312 1.33494 3.16877C1.39662 3.38294 1.47168 3.5918 1.55954 3.79377C1.12137 3.88953 0.726128 4.15581 0.441583 4.54695C0.157037 4.93809 0.000919058 5.42971 0 5.93752C0 7.81252 1.29431 10 4.9422 10H5.44191C5.4739 10.1898 5.49044 10.3825 5.49133 10.5756V12.5C5.50076 12.667 5.47882 12.8343 5.42697 12.9908C5.37511 13.1473 5.29453 13.2895 5.19061 13.4078C5.08668 13.526 4.96179 13.6178 4.82426 13.6768C4.68674 13.7358 4.53974 13.7608 4.39306 13.75H3.2948C3.14916 13.75 3.00948 13.8159 2.9065 13.9331C2.80352 14.0503 2.74566 14.2093 2.74566 14.375C2.74566 14.5408 2.80352 14.6998 2.9065 14.817C3.00948 14.9342 3.14916 15 3.2948 15H9.88439C10.03 15 10.1697 14.9342 10.2727 14.817C10.3757 14.6998 10.4335 14.5408 10.4335 14.375C10.4335 14.2093 10.3757 14.0503 10.2727 13.9331C10.1697 13.8159 10.03 13.75 9.88439 13.75H8.78942C8.64252 13.7611 8.49524 13.7364 8.3574 13.6776C8.21955 13.6187 8.09432 13.5271 7.99007 13.4088C7.88581 13.2905 7.80493 13.1482 7.75281 12.9915C7.7007 12.8348 7.67856 12.6672 7.68786 12.5V10.575C7.68878 10.382 7.70532 10.1896 7.73728 10ZM8.63566 8.21815C9.57658 7.26944 10.3906 6.16927 11.0518 4.95252C11.117 4.98322 11.1867 4.99934 11.2572 5.00002C11.4757 5.00002 11.6852 5.0988 11.8397 5.27461C11.9941 5.45043 12.0809 5.68888 12.0809 5.93752C12.0809 7.29752 11.0711 8.75002 8.23699 8.75002H8.20624C8.33006 8.55371 8.47424 8.37513 8.63566 8.21815ZM4.9422 8.75002C2.10812 8.75002 1.09827 7.29752 1.09827 5.93752C1.09827 5.68888 1.18505 5.45043 1.33952 5.27461C1.494 5.0988 1.70351 5.00003 1.92197 5.00002C1.99265 4.99942 2.06257 4.9833 2.12789 4.95252C2.78915 6.16927 3.60316 7.26944 4.54408 8.21815C4.7053 8.37517 4.8493 8.55375 4.97295 8.75002H4.9422Z"
                  fill="#637381"
                />
              </svg>
            </span>
          </Link>
          {/* <Link
            to="/allNotifications"
            onClick={() => {
              setunseenNotification(false);
              dispatch({ type: "UNSET_NOTIFICATION" });
            }}>
            <svg
              width="35"
              height="35"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mr-[10%] notification-event">
              {window.location.hash !== "#/allNotifications" && (
                <path
                  d="M11 29C12.7345 29 14.1414 27.4892 14.1414 25.625H7.85863C7.85863 27.4892 9.26554 29 11 29ZM21.5772 21.1051C20.6284 20.0104 18.8532 18.3635 18.8532 12.9688C18.8532 8.87129 16.1778 5.59121 12.5704 4.78648V3.6875C12.5704 2.75568 11.8672 2 11 2C10.1328 2 9.42956 2.75568 9.42956 3.6875V4.78648C5.82216 5.59121 3.14681 8.87129 3.14681 12.9688C3.14681 18.3635 1.37159 20.0104 0.422845 21.1051C0.128203 21.4453 -0.0024214 21.8519 3.3952e-05 22.25C0.00543572 23.1148 0.637443 23.9375 1.57637 23.9375H20.4236C21.3626 23.9375 21.9951 23.1148 22 22.25C22.0024 21.8519 21.8718 21.4447 21.5772 21.1051V21.1051Z"
                  fill="#ACACAC"
                />
              )}
              {window.location.hash === "#/allNotifications" && (
                <path
                  d="M11 29C12.7345 29 14.1414 27.4892 14.1414 25.625H7.85863C7.85863 27.4892 9.26554 29 11 29ZM21.5772 21.1051C20.6284 20.0104 18.8532 18.3635 18.8532 12.9688C18.8532 8.87129 16.1778 5.59121 12.5704 4.78648V3.6875C12.5704 2.75568 11.8672 2 11 2C10.1328 2 9.42956 2.75568 9.42956 3.6875V4.78648C5.82216 5.59121 3.14681 8.87129 3.14681 12.9688C3.14681 18.3635 1.37159 20.0104 0.422845 21.1051C0.128203 21.4453 -0.0024214 21.8519 3.3952e-05 22.25C0.00543572 23.1148 0.637443 23.9375 1.57637 23.9375H20.4236C21.3626 23.9375 21.9951 23.1148 22 22.25C22.0024 21.8519 21.8718 21.4447 21.5772 21.1051V21.1051Z"
                  fill="#008080"
                />
              )}
              {noti.filter((item) => item.seen === false).length !== 0 ? (
                <>
                  {" "}
                  <circle cx="17" cy="6" r="7" fill="#BE1E2D" />
                  <text
                    x="17"
                    y="7"
                    fill="white"
                    fontSize="10"
                    fontWeight="bold"
                    style={{ dominantBaseline: 'middle', textAnchor: 'middle' }}
                  >
                    {noti.filter((item) => item.seen === false).length}
                  </text>
                </>
              ) : (
                ""
              )}
            </svg>
          </Link> */}
        </div>
        <div>
          <Link className="" to="/profile">
            {user.profilePicture !== null && user.profilePicture ? (
              <Avatar
                alt="Profile"
                src={user.profilePicture}
                sx={{ width: 35, height: 35 }}
              />
            ) : user.gender === "male" ? (
              <Avatar alt="Profile" src={Man} sx={{ width: 35, height: 35 }} />
            ) : user.gender === "female" ? (
              <Avatar
                alt="Profile"
                src={Female}
                sx={{ width: 35, height: 35 }}
              />
            ) : user.gender === "others" ? (
              <Avatar
                alt="Profile"
                src={Others}
                sx={{ width: 35, height: 35 }}
              />
            ) : user.theme === "dark" ? (
              <Avatar
                alt="Profile"
                src={logoAntDark}
                sx={{ width: 35, height: 35 }}
              />
            ) : (
              <Avatar
                alt="Profile"
                src={logoAnt}
                sx={{ width: 30, height: 30 }}
              />
            )}
          </Link>
        </div>
      </div>
      {togglePostDropdown && (
        <>
          <div
            className="fixed top-0 left-0 w-[100vw] h-[100vh] bg-compBgSec text-primary opacity-80 z-[6]"
            onClick={handlePostDropdown}></div>
          <div
            className={`justify-between  fixed  w-[70%]  bg-card text-primary rounded-2xl shadow-lg bottom-[50%] left-[20%] z-[7]`}>
            <ul className="mx-2 w-[100%] ">
              <Link>
                <li
                  className="flex mx-[1%] my-[5%] items-center"
                  onClick={handletogglePostVideoContent}>
                  <VideocamIcon className="text-grayish mx-[10%]  mt-[2%]" />{" "}
                  <span className="mt-[2%] text-grayish">Post a Video</span>
                </li>
              </Link>
              {/* <hr className="border-viewMore" /> */}
              <Link>
                <li
                  className="flex mx-[1%] my-[5%] items-center"
                  onClick={handletogglePosImagetContent}>
                  <PhotoCameraIcon className="text-grayish mx-[10%]  mt-[2%]" />{" "}
                  <span className="mt-[2%] text-grayish">Post Image</span>
                </li>
              </Link>
              {/* <hr className="border-viewMore" /> */}
              <Link>
                <li
                  className="flex mx-[1%] my-[5%] items-center"
                  onClick={handletogglePostContent}>
                  <TextSnippetIcon className="text-slate-500 mx-[10%]  mt-[2%]" />{" "}
                  <span className="mt-[2%] text-grayish">Post a Content</span>
                </li>
              </Link>
              {/* <hr className="border-viewMore" /> */}
            </ul>
          </div>
        </>
      )}
      {togglePostContent && (
        <div>
          <UploadBlog settogglePostContent={settogglePostContent} />
        </div>
      )}

      {togglePostImageContent && (
        <div>
          <UploadImage settogglePostImageContent={settogglePostImageContent} />
        </div>
      )}

      {togglePostVideoContent && (
        <div>
          <UploadVideos settogglePostVideoContent={settogglePostVideoContent} />
        </div>
      )}
    </div>
  );
};

export default React.memo(MobileFooter);
